import { fromJS } from 'immutable';
import { TERMS_STATE } from './constants';

const lookupNested = (path, globalData) => {
  try {
    return path.split('.').reduce((currentObj, pathComponent) => {
      return currentObj[pathComponent];
    }, globalData);
  } catch (error) {
    return null;
  }
};

export default (globalData) => {
  const modal = lookupNested('modal', globalData);
  const rejectError = lookupNested('rejectError', globalData);
  const internalError = lookupNested('internalError', globalData);
  const termsContent = lookupNested('termsContent', globalData) || null;

  return fromJS({
    staticData: {
      modal, rejectError, internalError,
    },
    termsState: TERMS_STATE.HIDE,
    termsContent,
    page: null,
    loginValues: null,
    submit: false,
    internalError: false,
    userAccepted: true,
  });
};
